import React from "react";
import { House, Building2, Siren } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
const services = [{
  title: "uPVC Roofline Experts",
  description: "High-performance fascia, soffit, and guttering replacements that eliminate maintenance and enhance your home's curb appeal.",
  icon: House,
  link: "#"
}, {
  title: "Modern Dry Fix Systems",
  description: "Advanced dry verge and dry ridge solutions providing a secure, mortar-free finish that withstands the North East's harshest weather.",
  icon: Building2,
  link: "#"
}, {
  title: "EPDM Rubber Roofing",
  description: "The ultimate flat roof protection. Seamless, durable, and weather-proof rubber roofing designed to last for over five decades.",
  icon: Siren,
  link: "#"
}];
export default function ProtectionSolutions() {
  return <section data-section-id="35043" id="our-north-east-expertise" className="dark bg-background text-foreground py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <Link key={i} to={service.link} className="group block h-full" data-index={i}>
              <Card className="h-full bg-card border-2 border-border shadow-sm transition-all duration-300 ease-out hover:border-primary hover:shadow-xl hover:shadow-primary/10">
                <CardHeader className="pt-10 pb-2">
                  <div className="mb-6 flex justify-center">
                    <service.icon className="w-20 h-20 text-muted-foreground stroke-[1.5] transition-all duration-500 ease-out group-hover:text-primary group-hover:scale-110 group-hover:stroke-[2]" />
                  </div>
                  <CardTitle className="text-center text-2xl font-serif font-bold text-foreground group-hover:text-primary transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-center text-muted-foreground font-sans text-base leading-relaxed px-4">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}